export default __webpack_public_path__ + "static/same-visitor-12c2952b72c06f15a2abd4a74589055c.png";